<template>
  <basic-portlet :title="`${getFeedLabel(true)}s`">
    <template #portlet_actions>
      <button class="btn btn-ss btn-icon-sm" @click="importIndexFeed">
        <i class="la la-download" /> Import
      </button>
      <a href="/podcast/create" class="btn btn-ss-standout btn-icon-sm">
        <i class="la la-plus" /> Podcast
      </a>
    </template>
    <div v-if="fetching" class="d-flex flex-column align-items-center">
      <loader loading-text="Loading Podcasts..." />
    </div>
    <podcast-list v-else :feeds="customer_podcasts" @reload="fetchFeedsWithWebsiteData" />
    <feed-url-modal :name="import_modal_name" :callback="modalCallback" />
  </basic-portlet>
</template>

<script>
import { fetchFeeds } from "Lib/feeds";

import FeedsModalsMixin from "VueMixins/Feeds/FeedsModalsMixin";

import BasicPortlet from "VueComponents/BasicPortlet";
import Loader from "VuePartials/Loader";
import PodcastList from "VuePartials/Feeds/PodcastList";
import FeedUrlModal from 'VuePartials/Feeds/FeedUrlModal';

export default {
  components: { PodcastList, BasicPortlet, FeedUrlModal, Loader },
  mixins: [FeedsModalsMixin],
  data: () => ({
    customer_podcasts: [],
    fetching: false,
    import_modal_name: 'pc-index-import-modal',
  }),
  beforeMount() {
    this.init();
  },
  methods: {
    async init() {
      this.fetching = true;
      await this.fetchFeedsWithWebsiteData();
      this.fetching = false;
    },
    importIndexFeed() {
      this.modal_name_override = this.import_modal_name;
      this.importFeed();
    },
    async fetchFeedsWithWebsiteData() {
      const podcasts = (await fetchFeeds({
        with_player_data: true,
        sort: 'created_at|desc',
      }));

      // `Promise.all` to do everything in parallel
      // this is just a map which attaches the PCW data to each feed
      this.customer_podcasts = await Promise.all(
        podcasts.map(async (feed) => {
          try {
            const response = await axios.get(`/api/v1/podcast-websites/feed/${feed.uuid}`);
            if (response.data?.data) {
              feed.podcast_website = response.data.data;
            }
          } catch (error) {
            if (error.response.status !== 404) {
              window.handleAxiosError(error);
            }
          }
          return feed;
        }),
      );
    },
    addPodcastModal() {
      this.fireModal('quick_start_feed_create_modal');
    },
  },
};
</script>
